module.exports = __webpack_public_path__ + "shadow.png?6b7b0023b3606196ee191c110e067ab7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/shadow.png
// module id = 117
// module chunks = 0